import React from "react";
import { Box, Chip, Typography } from "@mui/material";

type Props = {
  meta?: any;
  onClear?: (key: string) => void;
};

export default function FilterContextBar({ meta, onClear }: Props) {
  if (!meta) return null;

  const items = [
    { key: "datefrom", label: "From", value: meta.dateFrom },
    { key: "dateto", label: "To", value: meta.dateTo },
    { key: "locationid", label: "Location ID", value: meta.locationId },
    { key: "salespersonid", label: "Salesperson ID", value: meta.salespersonId },
  ].filter((x) => x.value !== null && x.value !== undefined && x.value !== "");

  return (
    <Box
      sx={{
        mt: 1.5,
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexWrap: "wrap",
      }}
    >
      <Typography sx={{ fontSize: 12, color: "#66788A", fontWeight: 700 }}>
        Context:
      </Typography>

      {items.map((x) => {
        const clearable = ["locationid", "salespersonid"].includes(x.key);

        return (
          <Chip
            key={x.key}
            size="small"
            label={`${x.label}: ${x.value}`}
            onDelete={clearable ? () => onClear?.(x.key) : undefined}
            sx={{
              bgcolor: "#F3F8FC",
              color: "#163A5F",
              border: "1px solid #CFE3F4",
              fontWeight: 600,
            }}
          />
        );
      })}
    </Box>
  );
}
